import React from 'react';
import SelectButtons from './SelectButtons';
import {
  SectionHeading,
  StyledAsterisksText,
  SubSection,
  FormSection,
} from '@/shared/styles/styledComponents/editProfileForm';
import { Expertise, StylingPreference } from '@/shared/types/stylist';
import { ButtonSelectItem } from '@/shared/styles/types';
import useBreakpoint from '@/shared/hooks/useBreakpoint';

interface ExpertiseSectionProps {
  selectedExpertise: ButtonSelectItem[];
  setSelectedExpertise: React.Dispatch<
    React.SetStateAction<ButtonSelectItem[]>
  >;
  selectedStylingPreference: ButtonSelectItem[];
  setSelectedStylingPreference: React.Dispatch<
    React.SetStateAction<ButtonSelectItem[]>
  >;
}

const ExpertiseSection: React.FC<ExpertiseSectionProps> = ({
  selectedExpertise,
  setSelectedExpertise,
  selectedStylingPreference,
  setSelectedStylingPreference,
}) => {
  const { isDesktop } = useBreakpoint();
  return (
    <FormSection isDesktop={isDesktop} marginBottom={isDesktop ? 36 : 42}>
      <SectionHeading isDesktop={isDesktop}>Your Expertise</SectionHeading>
      <SubSection marginBottom={38}>
        <StyledAsterisksText>Areas Of Expertise*</StyledAsterisksText>
        <SelectButtons
          setSelectedItems={setSelectedExpertise}
          selectedItems={selectedExpertise}
          enumArray={Object.values(Expertise)}
        />
      </SubSection>
      <SubSection>
        <StyledAsterisksText>Styling Aesthetics*</StyledAsterisksText>
        <SelectButtons
          setSelectedItems={setSelectedStylingPreference}
          selectedItems={selectedStylingPreference}
          enumArray={Object.values(StylingPreference)}
        />
      </SubSection>
    </FormSection>
  );
};

export default ExpertiseSection;
